// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "TabsV2-module--limitWidthOnLargeScreens--YqPLq";
export var tab = "TabsV2-module--tab--VbpHX";
export var tabText = "TabsV2-module--tabText--79Xs3";
export var tabsWrapper = "TabsV2-module--tabsWrapper--HD76j";